module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "view--overflow-visible"
  }, [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('submenu'), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Settings_Group_WebhookUrl",
      "modelPath": "webhookUrl",
      "acc": "webhookUrl",
      "tooltip": "Webhook_Info_Tooltip"
    },
    model: {
      value: (_vm.tenant.webhookUrl),
      callback: function($$v) {
        _vm.$set(_vm.tenant, "webhookUrl", $$v)
      },
      expression: "tenant.webhookUrl"
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.L.localize('Webhook_Info'))
    }
  }), _vm._v(" "), _c('p', [_c('ul', [_c('li', [_vm._v("\n                        " + _vm._s(_vm.L.localize('Webhook_Info1')) + "\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.L.localize('Webhook_Info2')) + "\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.L.localize('Webhook_Info3')) + "\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.L.localize('Webhook_Info4')) + "\n                    ")])])]), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Label_SaveButton"
    },
    on: {
      "click": _vm.save
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27352e02!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/account/Webhook.vue
// module id = 717
// module chunks = 1